(() => {
  if (window.LFDSetupStorage) return;
  const validId = value => typeof value === 'string' && /^[A-Z]{2}[0-9]{6}$/.test(value);
  const validToken = value => typeof value === 'string' && value.length <= 12000 && /^[A-Za-z0-9_-]+$/.test(value);
  const cache = new Map();
  function config() {
    try { return JSON.parse(document.querySelector('[data-lfd-setup-storage]')?.textContent || '{}'); }
    catch { return {}; }
  }
  function endpoint() {
    const c = config();
    if (!c.enabled || typeof c.endpoint !== 'string') return '';
    try {
      const u = new URL(c.endpoint);
      return u.protocol === 'https:' && u.hostname === 'script.google.com' && !u.port && !u.username && !u.password &&
        /^\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(u.pathname) && !u.search && !u.hash ? u.href : '';
    } catch { return ''; }
  }
  async function request(action, value) {
    const base = endpoint();
    if (!base) throw new Error('unavailable');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const url = new URL(base);
      const options = {credentials: 'omit', redirect: 'follow', cache: 'no-store', signal: controller.signal};
      if (action === 'save' || action === 'email') {
        if (action === 'save' && !validToken(value)) throw new Error('invalid');
        if (action === 'email' && (!validId(value?.id) || typeof value.email !== 'string' || value.email.length > 254 ||
            typeof value.requestId !== 'string' || !/^[a-z0-9-]{20,80}$/i.test(value.requestId))) throw new Error('invalid');
        if (action === 'email' && value.botToken !== undefined &&
            (typeof value.botToken !== 'string' || value.botToken.length > 2048 || /\s/.test(value.botToken))) throw new Error('invalid');
        options.method = 'POST';
        options.headers = {'Content-Type': 'text/plain;charset=UTF-8'};
        options.body = JSON.stringify(action === 'save' ? {action, version: 1, token: value} :
          {action, version: 1, id: value.id, email: value.email, requestId: value.requestId,
            ...(value.botToken !== undefined ? {botToken: value.botToken} : {})});
      } else {
        if (!validId(value)) throw new Error('invalid');
        url.searchParams.set('action', 'load');
        url.searchParams.set('id', value);
      }
      const response = await fetch(url.href, options);
      if (!response.ok) throw new Error('unavailable');
      const raw = await response.text();
      if (raw.length > 16000) throw new Error('invalid');
      const result = JSON.parse(raw);
      if (action === 'email' && result?.ok === false) {
        const allowed = ['email_disabled', 'email_test_only', 'email_limited', 'email_uncertain', 'email_verification', 'email_verification_unavailable'];
        throw new Error(allowed.includes(result.error) ? result.error : 'unavailable');
      }
      if (!result || result.ok !== true || result.version !== 1 || !validId(result.id)) throw new Error('unavailable');
      if (action === 'load' && (result.id !== value || !validToken(result.token))) throw new Error('invalid');
      if (action === 'email' && (result.id !== value.id || result.emailStatus !== 'sent')) throw new Error('invalid');
      return result;
    } finally { clearTimeout(timer); }
  }
  window.LFDSetupStorage = {
    enabled: () => !!endpoint(),
    validId,
    text: key => config().copy?.[key] || '',
    emailMode: () => ['preview', 'test'].includes(config().emailMode) ? config().emailMode : 'off',
    emailBotProtection: () => ({enabled: config().emailBotEnabled === true, sitekey: String(config().emailBotSitekey || '').trim()}),
    async email(value) {
      if (config().emailMode !== 'test') throw new Error('email_disabled');
      return request('email', value);
    },
    async save(token) {
      const key = endpoint() + ':' + token;
      if (cache.has(key)) return cache.get(key);
      const pending = request('save', token).then(result => result.id);
      cache.set(key, pending);
      try { return await pending; }
      catch (error) { cache.delete(key); throw error; }
      finally { if (cache.size > 20) cache.delete(cache.keys().next().value); }
    },
    async load(id) { return (await request('load', id)).token; }
  };
})();
